import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Drawer, Field, Input, Select, PowerSelect } from '@itds/elements/index.js';

import Api from '@carrier/utils/Api';

const New = ({ carrier, onClose, onSave, show, vendors }) => {
  const [data, setData] = useState({
    vendor_id: '',
    name: '',
    url: '',
    business_type: 'Comparison Aggregator'
  });

  const handleInputChange = (name, e) => {
    setData({ ...data, [name]: e.target.value });
  };

  const handleVendorChange = selected => {
    if (selected['__isNew__']) {
      setData({ ...data, vendor_id: null, name: selected.value });
    } else {
      setData({ ...data, vendor_id: selected.value });
    }
  };

  const handleSave = () => {
    const { vendor_id, name, url, business_type } = data;

    if (vendor_id) {
      Api.createVendorCarrierRelationship({ carrier_id: carrier.id, vendor_id }).then(() => {
        onSave();
      });
    } else {
      Api.createVendor({ name, url, business_type }).then(({ data }) => {
        Api.createVendorCarrierRelationship({ carrier_id: carrier.id, vendor_id: data.id }).then(
          () => {
            onSave();
          }
        );
      });
    }
  };

  return (
    <Drawer
      alignRight={true}
      footer={<Button onClick={handleSave}>Create Vendor Relationship</Button>}
      onClose={onClose}
      show={show}
      title='New Vendor Relationship'
    >
      <Field label='Vendor'>
        <PowerSelect
          creatable={true}
          onChange={handleVendorChange}
          options={vendors.map(v => ({ value: v.id, label: v.name }))}
          placeholder='Search by name...'
        />
      </Field>

      {data.vendor_id || !data.name ? null : (
        <>
          <Field label='Website URL'>
            <Input onChange={handleInputChange.bind(null, 'url')} value={data.url} />
          </Field>

          <Field label='Business Type'>
            <Select
              onChange={handleInputChange.bind(null, 'business_type')}
              options={[
                { value: 'Comparison Aggregator' },
                { value: 'Digital Marketer' },
                { value: 'IMO/BGA' },
                { value: 'Captive Agency' },
                { value: 'Carrier Tool' },
                { value: 'Other' }
              ]}
              value={data.business_type}
            />
          </Field>
        </>
      )}
    </Drawer>
  );
};

New.propTypes = {
  carrier: PropTypes.object,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  show: PropTypes.bool,
  vendors: PropTypes.array
};

export default New;
